'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  margin: 0px;\n  ', '\n'], ['\n  margin: 0px;\n  ', '\n']),
    _templateObject2 = _taggedTemplateLiteral([''], ['']),
    _templateObject3 = _taggedTemplateLiteral(['\n  margin: 0.5em 0px;\n'], ['\n  margin: 0.5em 0px;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  margin: 0px;\n  width: 100%;\n  position: relative;\n  border-top: none;\n  height: auto;\n  margin-bottom: 10px;\n'], ['\n  margin: 0px;\n  width: 100%;\n  position: relative;\n  border-top: none;\n  height: auto;\n  margin-bottom: 10px;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  float: right;\n'], ['\n  float: right;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  ', '\n'], ['\n  ', '\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _color = require('../color');

var _color2 = _interopRequireDefault(_color);

var _ramda = require('ramda');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } // @Todo to make transition smoother, we can close all pannel first (wait for all animation done) before open the one being clicked on.

var Animation = _styledComponents2.default.div(_templateObject, function (props) {
  if (props.accordion) {
    return props.titleStyle ? 'max-height: 100em; overflow-y: ' + (typeof props.anistyle !== 'undefined' ? props.anistyle.overflow : 'auto') + '; overflow-x: ' + (typeof props.anistyle !== 'undefined' ? props.anistyle.overflow : 'hidden') + '; transition: all 0.6s cubic-bezier(0, 1, 0, 1);' : 'max-height: 0em; overflow-y: ' + (typeof props.anistyle !== 'undefined' ? props.anistyle.overflow : 'auto') + '; overflow-x: ' + (typeof props.anistyle !== 'undefined' ? props.anistyle.overflow : 'hidden') + '; transition: all 0.6s cubic-bezier(0, 1, 0, 1);';
  } else {
    return 'max-height: 100em; overflow-y: auto; overflow-x: hidden;';
  }
});

var AccordionContainer = _styledComponents2.default.div(_templateObject2);

var Container = _styledComponents2.default.div(_templateObject3);

var ContentDiv = _styledComponents2.default.div(_templateObject4);

var ArrowSpan = _styledComponents2.default.span(_templateObject5);

var AccordionStyle = _styledComponents2.default.div(_templateObject6, function (props) {
  return props.accordion ? '' : 'padding: 0.5em 1em;';
});

var MozartAccordion = function (_Component) {
  _inherits(MozartAccordion, _Component);

  function MozartAccordion(props) {
    _classCallCheck(this, MozartAccordion);

    var _this = _possibleConstructorReturn(this, (MozartAccordion.__proto__ || Object.getPrototypeOf(MozartAccordion)).call(this, props));

    _this.state = {
      toggle_key: _this.getInitData()
    };
    return _this;
  }

  _createClass(MozartAccordion, [{
    key: 'getCloseItem',
    value: function getCloseItem(item) {
      return _defineProperty({}, item.title, false);
    }
  }, {
    key: 'getInitData',
    value: function getInitData() {
      var contents = this.props.contents;

      return (0, _ramda.mergeAll)(contents.map(this.getCloseItem));
    }
  }, {
    key: 'onEnter',
    value: function onEnter(name) {
      this.refs[name].className = 'icon-Down';
    }
  }, {
    key: 'onExit',
    value: function onExit(name) {
      this.refs[name].className = 'icon-Right';
    }
  }, {
    key: 'toggle',
    value: function toggle(title) {
      var initData = this.getInitData();
      initData[title] = !this.state.toggle_key[title];
      this.setState({
        toggle_key: initData
      });
    }
  }, {
    key: 'clickTransition',
    value: function clickTransition(index) {
      var node = _reactDom2.default.findDOMNode(this.refs[index]);
      node.className = 'transition';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          contents = _props.contents,
          accordion = _props.accordion;

      var DATA = [];
      var styles = {
        divActive: {
          borderTop: 'none',
          paddingBottom: '15px',
          border: '1px solid ' + _color2.default.blue_accent,
          borderBottomLeftRadius: '5px',
          borderBottomRightRadius: '5px',
          marginBottom: '10px',
          textAlign: 'left',
          padding: '1em',
          margin: '0px'
        },

        divInactive: {
          border: 'none',
          textAlign: 'left',
          padding: '0em',
          margin: '0px'
        },

        accordionDivStyle: {
          borderTop: 'none',
          paddingBottom: '15px',
          border: '1px solid ' + _color2.default.blue_accent,
          borderBottomLeftRadius: '5px',
          borderBottomRightRadius: '5px',
          marginBottom: '10px',
          textAlign: 'left',
          padding: '1em',
          margin: '0px'
        },

        headerActive: {
          border: '1px solid ' + _color2.default.blue_accent,
          borderRadius: '5px',
          margin: '0px',
          boxSizing: 'border-box',
          backgroundColor: '' + _color2.default.blue_main,
          cursor: 'pointer',
          fontSize: '14px',
          color: '' + _color2.default.white,
          borderBottomLeftRadius: '0px',
          borderBottomRightRadius: '0px'
        },

        headerInactive: {
          border: '1px solid ' + _color2.default.blue_accent,
          borderRadius: '5px',
          margin: '0px',
          boxSizing: 'border-box',
          backgroundColor: 'transparent',
          cursor: 'pointer',
          fontSize: '14px',
          color: '' + _color2.default.grey_main,
          borderBottomLeftRadius: '5px',
          borderBottomRightRadius: '5px'
        },

        accordionHeaderStyle: {
          border: '1px solid ' + _color2.default.blue_accent,
          borderRadius: '5px',
          margin: '0px',
          boxSizing: 'border-box',
          background: 'linear-gradient(90deg, ' + _color2.default.blue_accent + ' 0%, ' + _color2.default.blue_main + ' 100%)',
          fontSize: '14px',
          color: '' + _color2.default.white,
          borderBottomLeftRadius: '0px',
          borderBottomRightRadius: '0px'
        },
        caratActive: 'icon-Down',
        caratInactive: 'icon-Right'
      };

      contents.forEach(function (item, index) {
        var divStyle = _this2.state.toggle_key[item.title] === true ? styles.divActive : styles.divInactive;
        var accordionDivStyle = accordion === true ? divStyle : styles.accordionDivStyle;
        var headerStyle = _this2.state.toggle_key[item.title] === true ? styles.headerActive : styles.headerInactive;
        var accordionHeaderStyle = accordion === true ? headerStyle : styles.accordionHeaderStyle;
        var carat = _this2.state.toggle_key[item.title] === true ? styles.caratActive : styles.caratInactive;
        DATA.push(_react2.default.createElement(
          Container,
          { key: index, className: item.title.toLowerCase ? item.title.toLowerCase().split(' ').join('_') : '' },
          _react2.default.createElement(
            AccordionStyle,
            { ref: index, accordion: true, onClick: function onClick() {
                _this2.toggle(item.title);_this2.clickTransition(index);
              }, style: accordionHeaderStyle },
            _react2.default.createElement(
              'span',
              { style: { display: 'block', width: '100%', fontWeight: '400', height: '40px', padding: '10px 20px' } },
              item.title,
              ' ',
              accordion && _react2.default.createElement(ArrowSpan, { ref: item.title, className: carat })
            )
          ),
          _react2.default.createElement(
            Animation,
            { anistyle: _this2.state.toggle_key[item.title] ? item.style : undefined, titleStyle: _this2.state.toggle_key[item.title], accordion: accordion },
            _react2.default.createElement(
              ContentDiv,
              { style: accordionDivStyle },
              item.data
            )
          )
        ));
      });

      return _react2.default.createElement(
        AccordionContainer,
        { 'data-qa': this.props.testId, 'data-theme': this.props.themeId },
        DATA
      );
    }
  }]);

  return MozartAccordion;
}(_react.Component);

MozartAccordion.propTypes = {
  /** qa attribute */
  testId: _propTypes2.default.string,
  /** theme attribute */
  themeId: _propTypes2.default.string,
  /** If false all expanded by default */
  accordion: _propTypes2.default.bool,
  /** Array of object {title, data, customClassName} */
  contents: _propTypes2.default.array.isRequired
};
MozartAccordion.defaultProps = {
  accordion: true,
  testId: 'MozartAccordion',
  themeId: 'MozartAccordion'
};
exports.default = MozartAccordion;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Mozart/MozartAccordion/MozartAccordion.js
// module id = 1624
// module chunks = 1